@if (label) {
  <h4>{{ label }}</h4>
}
@if (control) {
  <mat-radio-group
    aria-label="label"
    [formControl]="control"
    class="example-radio-group"
    [ngClass]="layout"
    (change)="onChange($event)"
  >
    @for (option of options; track option) {
      <mat-radio-button [value]="option.id" [checked]="option.id === selected">
        @if (optionLabelTemplate) {
          <ng-container
            *ngTemplateOutlet="optionLabelTemplate; context: { label: option.name }"
          ></ng-container>
        } @else {
          {{ option.name | translate }}
        }
      </mat-radio-button>
    }
  </mat-radio-group>
}
